import { useState } from "react";
import { useSite } from "@/lib/content";
import { Checkbox, LiveIndicator, SaveButton, SectionHeader, useSaver } from "@/pages/admin/ui";

const STATUSES = [["", "Durum yok"], ["mevcut", "Mevcut"], ["önerilen", "Önerilen"], ["planlanan", "Planlanan"]];

function EnBlock({ m, onChange }) {
  const en = m.en || { title: "", body: null, verified: false };
  const set = (patch) => onChange({ ...m, en: { ...en, ...patch } });
  const trLive = m.visible && m.verified && !!(m.body || "").trim();
  return (
    <div className="rounded-xl border border-dashed border-line bg-cream p-4 space-y-3" data-testid={`admin-module-${m.id}-en`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-semibold text-wood">İngilizce (EN)</p>
        <LiveIndicator live={trLive && en.verified && !!(en.body || "").trim() && !!(en.title || "").trim()} testId={`admin-module-${m.id}-en-live`} />
      </div>
      <input value={en.title || ""} onChange={(e) => set({ title: e.target.value })} placeholder="English title" aria-label="İngilizce başlık" className="w-full rounded-xl border border-line px-4 py-2.5 text-base" data-testid={`admin-module-${m.id}-en-title`} />
      <textarea rows={3} value={en.body || ""} onChange={(e) => set({ body: e.target.value })} placeholder="English description" aria-label="İngilizce açıklama" className="w-full rounded-xl border border-line px-4 py-3 text-base" data-testid={`admin-module-${m.id}-en-body`} />
      <Checkbox id={`me-${m.id}`} label="EN Doğrulandı" checked={en.verified} onChange={(v) => set({ verified: v })} testId={`admin-module-${m.id}-en-verified`} />
    </div>
  );
}

function ModuleCard({ m, onChange }) {
  const live = m.visible && m.verified && !!(m.body || "").trim();
  return (
    <div className="rounded-2xl border border-line bg-white p-5 space-y-4" data-testid={`admin-module-${m.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h3 className="text-2xl font-semibold text-forest">{m.title}</h3>
        <LiveIndicator live={live} testId={`admin-module-${m.id}-live`} />
      </div>
      <label className="block text-sm font-semibold text-wood space-y-2">
        <span>Açıklama</span>
        <textarea rows={4} value={m.body || ""} onChange={(e) => onChange({ ...m, body: e.target.value })} className="w-full rounded-xl border border-line px-4 py-3 text-base font-normal text-ink" data-testid={`admin-module-${m.id}-body`} />
      </label>
      <EnBlock m={m} onChange={onChange} />
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        <label className="inline-flex items-center gap-2 text-sm font-medium">
          Durum
          <select value={m.status || ""} onChange={(e) => onChange({ ...m, status: e.target.value || null })} className="min-h-[44px] rounded-xl border border-line px-3 bg-white text-base" data-testid={`admin-module-${m.id}-status`}>
            {STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
        </label>
        <Checkbox id={`mv-${m.id}`} label="Görünür" checked={m.visible} onChange={(v) => onChange({ ...m, visible: v })} testId={`admin-module-${m.id}-visible`} />
        <Checkbox id={`md-${m.id}`} label="Doğrulandı" checked={m.verified} onChange={(v) => onChange({ ...m, verified: v })} testId={`admin-module-${m.id}-verified`} />
      </div>
    </div>
  );
}

export default function ModulesSection() {
  const { content } = useSite();
  const [mods, setMods] = useState(() => content.modules.map((m) => ({ ...m })));
  const { save, saving } = useSaver();
  const onSave = () => save([["modules", mods.map((m) => ({ id: m.id, body: (m.body || "").trim() || null, status: m.status || null, visible: !!m.visible, verified: !!m.verified, en: { title: (m.en?.title || "").trim() || null, body: (m.en?.body || "").trim() || null, verified: !!m.en?.verified } }))]]);

  return (
    <section data-testid="admin-section-moduller">
      <SectionHeader title="Modüller" text="Canlı sitede görünmesi için modülün açıklaması dolu, “Görünür” ve “Doğrulandı” işaretli olmalıdır. Durum etiketi yalnızca önizlemede gösterilir." />
      <div className="space-y-4">
        {mods.map((m, i) => <ModuleCard key={m.id} m={m} onChange={(n) => setMods(mods.map((x, j) => (j === i ? n : x)))} />)}
      </div>
      <div className="mt-6"><SaveButton onClick={onSave} saving={saving} testId="admin-save-moduller" /></div>
    </section>
  );
}
